import { FeatureNames } from "./flags";
import { FeatureFlagState } from "./types";

// // // //

/**
 * DEFAULT_FEATURE_FLAGS
 * Defines hard-coded default values for feature flags
 * NOTE - this mostly exists for better typesafety throughout the platform, or if something goes wrong with PostHog
 */
export const DEFAULT_FEATURE_FLAGS: FeatureFlagState = {
    // // // //
    // App Features
    [FeatureNames.enableDataDownloads]: false,

    // // // //
    // API Tools
    [FeatureNames.enableApiKeys]: false,

    // // // //
    // MCP Tools
    [FeatureNames.enableMcpTools]: false,

    // // // //
    // Admin Tools
    [FeatureNames.enableAdminTools]: false,

    // // // //
    // Experimental Features
    [FeatureNames.enableExperimentalFeatures]: false,
    [FeatureNames.enableChartsPages]: false,
};
